export function makeRequired(errorMsg: string, getException?: () => boolean) {
  return (value: unknown) => {
    const isException = getException && getException();

    if (isException) {
      return undefined;
    }

    return !value || (Array.isArray(value) && value.length === 0) || (typeof value === 'string' && !value.trim())
      ? errorMsg
      : undefined;
  };
}
